import { render, staticRenderFns } from "./FormPlaceholder.vue?vue&type=template&id=3b17719a&scoped=true"
import script from "./FormPlaceholder.vue?vue&type=script&lang=js"
export * from "./FormPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./FormPlaceholder.vue?vue&type=style&index=0&id=3b17719a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b17719a",
  null
  
)

export default component.exports